<template>
  <div class="view pa24">
    <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="auto">
      <el-form-item :label="$t('marketing', 'activityType')" prop="killType">
        <el-select v-model="ruleForm.killType" :disabled='$route.query.id ? true : false'>
          <el-option
            v-for="(item, index) in types"
            :key="index"
            :label="item.label"
            :value="item.id"
          >
            {{ item.label }}
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item :label="$t('marketing', 'activityDuration')" prop="pickerValue">
        <el-date-picker
          v-model="ruleForm.pickerValue"
          value-format="yyyy-MM-dd"
          align="right"
          type="daterange"
          :start-placeholder="$t('marketing', 'startDate')"
          :end-placeholder="$t('marketing', 'endDate')"
          :picker-options="pickerOptions"
        />
      </el-form-item>
      <el-form-item :label="$t('marketing', 'maxPurchasePerAccount')">
        <el-input-number
          :disabled='$route.query.id ? true : false'
          v-model="ruleForm.maxPurchase"
          :min="1"
        ></el-input-number>
      </el-form-item>
      <el-form-item :label="$t('marketing', 'addFlashSaleProduct')" v-if="$route.query.id ? false : true">
        <el-button type="primary" @click="centerDialogVisible = true"
          >{{ $t('marketing', 'addProduct') }}</el-button
        >
      </el-form-item>
    </el-form>
    <commonTable :tableData="tableData" :total="tableData.length" :paginationVisible='false'>
      <template v-slot:table>
        <el-table-column
          prop="goodsId"
          align="center"
          :label="$t('marketing', 'productId')"
          show-overflow-tooltip
        />
        <el-table-column prop="goodsName" align="center" :label="$t('marketing', 'product')" />
        <el-table-column align="center" prop="goodsTypeName" :label="$t('marketing', 'category')" />
        <el-table-column prop="price" align="center" :label="$t('marketing', 'price')">
          <template slot-scope="scope">
            {{  (scope.row[ $route.query.id ?'minPrice':'price'] / 100).toFixed(2) }}
          </template>
        </el-table-column>
        <el-table-column prop="stockNum" align="center" :label="$t('marketing', 'stock')" />
        <el-table-column :prop=" $route.query.id ? 'totalBuyNum':'dealNum'" align="center" :label="$t('marketing', 'totalSales')" />
        <el-table-column align="center" :label="$t('marketing', 'publishTime')">
          <template slot-scope="scope">
            {{ setGetDataTimeSec(scope.row.createTime) }}
          </template>
        </el-table-column>
      </template>
    </commonTable>
    <p class="">{{ $t('marketing', 'selectProductSpec') }}</p>
    <commonTable :tableData="specList" :total="specList.length">
      <template v-slot:table>
        <el-table-column
          prop="goodsName"
          align="center"
          :label="$t('marketing', 'productName')"
          show-overflow-tooltip
        />
        <el-table-column prop="typeName" align="center" :label="$t('marketing', 'productType')" />
        <el-table-column align="center" prop="specAttribute" :label="$t('marketing', 'productSpec')" />
        <el-table-column prop="stockNum" align="center" :label="$t('marketing', 'productStock')" />
        <el-table-column prop="price" align="center" :label="$t('marketing', 'price')">
          <template slot-scope="scope">
            {{ (scope.row.price / 100).toFixed(2) }}
          </template>
        </el-table-column>
        <el-table-column align="center" :label="$t('marketing', 'operation')" width="500">
          <template slot-scope="scope">
            {{ $t('marketing', 'flashSaleAmount') }}
            <el-input
               @change="() => {
                setSpec[scope.$index].killPrice =  setSpec[scope.$index].killPrice < 0.01 ? 0.01 : setSpec[scope.$index].killPrice
              }"
              class="d-inline-block w100"
              v-model="setSpec[scope.$index].killPrice"
            />
            {{ $t('marketing', 'yuan') }} {{ $t('marketing', 'activityStock') }}
            <el-input
              class="d-inline-block w100"
               @change="() => {
                setSpec[scope.$index].killNum =  setSpec[scope.$index].killNum < 1 ? 1 : setSpec[scope.$index].killNum.replace(/\D/g,'')
              }"
              v-model="setSpec[scope.$index].killNum"
            />
          </template>
        </el-table-column>
      </template>
    </commonTable>
    <el-dialog
      :title="$t('marketing', 'selectProduct')"
      :visible.sync="centerDialogVisible"
      :modal-append-to-body="false"
      :destroy-on-close="true"
      width="60%"
      center
    >
      <product v-if="centerDialogVisible" ref="product" />
      <span slot="footer" class="dialog-footer">
        <el-button @click="centerDialogVisible = false">{{ $t('marketing', 'cancel') }}</el-button>
        <el-button type="primary" @click="determine">{{ $t('marketing', 'confirm') }}</el-button>
      </span>
    </el-dialog>
    <div class="mt20 d-flex justify-content-center" v-if="$route.query.id ? false : true">
      <el-button @click="save(0)" type="primary">{{ $t('marketing', 'saveToDrafts') }}</el-button>
      <el-button @click="save(1)">{{ $t('marketing', 'publish') }}</el-button>
    </div>
    <div class="mt20 d-flex justify-content-center" v-else>
      <el-button type="primary" @click="save(draftType)">{{ $t('marketing', 'saveEdit') }}</el-button>
    </div>
  </div>
</template>

<script>
import commonTable from "@/components/common/commonTable";
import product from "./product";
import { getDataTimeSec } from "@/utils";
import { addKillGoodsInfo, updateKillGoodsInfo } from "@/api/marketingActivities";
import i18nMixin from '@/mixins/i18nMixin';

export default {
  mixins: [i18nMixin],
  data() {
    return {
      ruleForm: {
        killType: "", // 活动类型
        pickerValue: "",
        maxPurchase: "",
      },

      pickerOptions: {
        disabledDate(time) {
          return time.getTime() <= Date.now() - 24 * 60 * 60 * 1000;
        },
      },
      tableData: [],
      specList: [],
      setSpec: [],
      centerDialogVisible: false,
      draftType:'',
      killNo:''//编号
    };
  },
  computed: {
    setGetDataTimeSec() {
      return (val) => getDataTimeSec(val);
    },
    // 将rules移到computed中，确保可以访问this.$t
    rules() {
      return {
        killType: [{ required: true, message: this.$t('marketing', 'pleaseSelectActivityType') }],
        pickerValue: [{ required: true, message: this.$t('marketing', 'pleaseSelectActivityDuration') }],
      };
    },
    // 将types移到computed中，确保可以访问this.$t
    types() {
      return [
        { label: this.$t('marketing', 'limitedTimeFlashSale'), id: 1 },
        { label: this.$t('marketing', 'promotionalFlashSale'), id: 2 },
      ];
    },
  },
  components: {
    commonTable,
    product,
  },
  created(){
    const { id } = this.$route.query;
    if(id){
      this.updateKillGoodsInfo(id);
    }
    
    // 监听语言变化，强制更新组件
    this.$root.$on('language-changed', () => {
      this.$forceUpdate();
    });
  },
  beforeDestroy() {
    // 清理事件监听
    this.$root.$off('language-changed');
  },
  methods: {
    determine() {
      const { multipleSelection } = this.$refs.product;
      if (!multipleSelection || !multipleSelection.goodSpecModelList) {
        this.$message({
          message: this.$t('marketing', 'pleaseSelectProductFirst'),
          type: "warning",
        });
        return;
      }
      
      const arr = [];
      this.setSpec = [];
      this.tableData = [multipleSelection];
      for (let i = 0; i < multipleSelection.goodSpecModelList.length; i++) {
        let type = multipleSelection.goodSpecModelList[i];
        if (!type || !type.goodSpecModelList) continue;
        
        for (let j = 0; j < type.goodSpecModelList.length; j++) {
          let spec = type.goodSpecModelList[j];
          if (!spec) continue;
          
          spec.goodsName = multipleSelection.goodsName;
          spec.typeName = type.specName;
          spec.stockNum = multipleSelection.stockNum;
          this.setSpec.push({
            killPrice: "",
            killNum: "",
            stockNum: spec.stockNum,
            price: spec.price,
            specId: spec.specId,
          });
          arr.push(spec);
        }
      }
      this.specList = arr;
      this.centerDialogVisible = false;
    },
    /**@method  发布*/
    save(type) {
      if (this.tableData.length == 0) {
        this.$message({
          message: this.$t('marketing', 'pleaseSelectProductFirst'),
          type: "warning",
        });
        return;
      }
      
      // 检查setSpec是否已初始化
      if (!this.setSpec || this.setSpec.length === 0) {
        this.$message({
          message: this.$t('marketing', 'pleaseSelectProductFirst'),
          type: "warning",
        });
        return;
      }
      
      const checkPrice = this.setSpec.find((item) => item.killPrice <= 0);
      if (checkPrice) {
        this.$message({
          message: this.$t('marketing', 'flashSaleAmountCannotBeLessThanZero'),
          type: "warning",
        });
        return;
      }
      console.log(this.setSpec)
      for (let i = 0; i < this.setSpec.length; i++) {
        const spec = this.setSpec[i];
        if (!spec) continue; // 跳过无效的规格项
        
        if (!spec.killPrice || !spec.killNum) {
          this.$message({
            message: this.$t('marketing', 'flashSaleAmountAndStockCannotBeEmpty'),
            type: "warning",
          });
          return;
        }
        if (spec.killPrice * 100 > spec.price) {
          this.$message({
            message: this.$t('marketing', 'flashSaleAmountCannotExceedProductPrice'),
            type: "warning",
          });
          return;
        }
        if (spec.killNum > spec.stockNum) {
          this.$message({
            message: this.$t('marketing', 'flashSaleQuantityCannotExceedTotalStock'),
            type: "warning",
          });
          return;
        }
      }
      let temp = this.setSpec.map((item) => {
        return {
          specId: item.specId,
          killPrice: item.killPrice * 100,
          killNum: item.killNum,
        };
      });
      let data = {
        killId: this.tableData[0].killId,
        draftType: type,
        goodSpecRequestList: temp,
        killNo:this.killNo,
        goodsId: this.tableData[0].goodsId,
        startTime: `${this.ruleForm.pickerValue[0]} 00:00:00`,
        endTime:`${ this.ruleForm.pickerValue[1]} 23:59:59`,
        killType: this.ruleForm.killType,
        maxPurchase: this.ruleForm.maxPurchase,
        updateType: this.$route.query?.drafts == '1' ? 1 : 0,
      };

      if(this.$route.query.id) delete data.killNo;
      if(!this.$route.query.id) delete data.killId;
      this.$refs.ruleForm.validate(async (valid) => {
        if (valid) {
          try {
            await addKillGoodsInfo(data);
            this.$message({
              message: type == 1 ? this.$t('marketing', 'publishSuccess') : this.$t('marketing', 'saveSuccess'),
              type: "success",
            });
            setTimeout( () => {
              this.$router.go(-1);
            }, 1000);
          } catch (error) {
            if(error.code == 201){
              this.$message.error( error.message );
            }else{
              this.$message.error(type == 1 ? error.message || this.$t('marketing', 'publishFailed') : this.$t('marketing', 'saveFailed'));
            }
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    /**@method 获取编辑内容 */
   async updateKillGoodsInfo(id){
     const result = await updateKillGoodsInfo({killId:id},{ showLoading: true });
     const { killType, startTime, endTime, maxPurchase, goodSpecModelList, goodsName, stockNum, killNo, draftType } = result.data;
     this.ruleForm.killType = killType;
     this.ruleForm.pickerValue = [this.setGetDataTimeSec(startTime),this.setGetDataTimeSec(endTime)];
     this.ruleForm.maxPurchase = maxPurchase;
     this.tableData = [result.data];
     this.killNo = killNo;
     this.draftType = draftType;
      const arr = [];
     this.setSpec = [];
     for (let i = 0; i < goodSpecModelList.length; i++) {
        let type = goodSpecModelList[i];
        for (let j = 0; j < type.goodSpecModelList.length; j++) {
          let spec = type.goodSpecModelList[j];
          spec.goodsName = goodsName;
          spec.typeName = type.specName;
          spec.stockNum = stockNum;
          this.setSpec.push({
            killPrice: spec.killPrice / 100,
            killNum: spec.killNum,
            stockNum: spec.stockNum,
            price: spec.price,
            specId: spec.specId,
          });
          arr.push(spec);
        }
      }
     this.specList = arr;
    }
  },
};
</script>

<style lang="scss" scoped>
</style>
